module.exports = __webpack_public_path__ + "img/addimgbg.74165aec.jpg";